import React from "react";
import Select from "react-select";
import Overlay from "../Overlay";
import {
    getBoolSelectOptions,
    getBoolSelectVal, getNumPages, getPageOptions, hideModal,
    parseDate,
    showModalNoOutsideClick,
    slicePages
} from "../../util/FormatUtil";
import {sweetalert} from '../../App';
import SystemAPI from "../../network/SystemAPI";
import AdminAPI from "../../network/AdminAPI";
import {AdminPages} from "./AdminNav";
import FilterCard, {FIELD_TYPE, ReactSelect} from "../FilterCard";
import NetworkUtil from "../../network/NetworkUtil";
import {Column} from "../tables/TableBase";
import {Sorter, TableOrder} from "../../sorting/Sorter";
import SimpleTable from "../tables/SimpleTable";
import InBetweenOverlay from "../InBetweenOverlay";
import { Patient } from "../../types/Patient";
import PatientAPI from "../../network/PatientAPI";
import { PatientManagementModal } from "../modals/PatientManagementModal";


const ITEMS_PER_PAGE = 25;

interface PatientManagementState {
    selectedPatient?;
    patients: Patient[]
    showLoading?
    showInBetween?
    filter?:{
        SelectedPatient
    }
    tableData:{}[]
    direction?:TableOrder
    page_options:ReactSelect[]
    selected_page?:{label,value}
    patientQueryResults:Patient[]
    races
    genders
    ethnicities
    states
    countries
    facilities
}

export class PatientManagement extends React.Component<any, PatientManagementState> {

    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            showInBetween: false,
            patients: [],
            selectedPatient: {} as Patient,
            filter: {SelectedPatient:[],
            },
            tableData: [] as any,
            direction: 'asc',
            page_options: [{label: "1", value: "1"}],
            selected_page: {label: "1", value: 1},
            patientQueryResults: [] as any,
            races: [],
            genders: [],
            ethnicities: [],
            states: [],
            countries: [],
            facilities: []
        }
        this.modifyPatient = this.modifyPatient.bind(this);
    }


    componentDidMount() {
        this.setState({showLoading: true}, () => {
            SystemAPI.getAllRaces().then((data) => {
                this.setState({ races: data });
            });
            SystemAPI.getAllGenders().then((data) => {
                this.setState({ genders: data });
            });
            SystemAPI.getAllEthnicities().then((data) => {
                this.setState({ ethnicities: data });
            });
            SystemAPI.getAllStates().then((data) => {
                this.setState({ states: data });
            });
            AdminAPI.getAllFacilities().then((data) => {
                this.setState({facilities: data.authorizedFacilities});
            });
            SystemAPI.getAllCountries().then((data) => {
                this.setState({ countries: data, showLoading: false });
            });
            
        })
    }

    queryPatients(page:number) {
        this.setState({showLoading:true}, async () => {
            try {
                let results = await PatientAPI.filterPatients(this.state.filter)
                if (results.data.length === 0) {
                    sweetalert.fire({
                      icon: "error",
                      title: "",
                      text: "No patients were returned",
                    });
                  }

                if(!results.success){
                    return sweetalert.fire({title: '', text: 'Unable to filter Patient data at this time', icon: 'error'})
                }
                this.setState({
                    tableData: slicePages(results.data, page, ITEMS_PER_PAGE),
                    patientQueryResults: results.data,
                    page_options: getPageOptions(getNumPages(results.data, ITEMS_PER_PAGE)),
                    showLoading: false,
                })
            } catch (e) {
                console.error(e)
                this.setState({showLoading: false})
            }
        })
    }


    modifyPatient(patient:Patient){
        patient.guardianFirstName = patient.guardianFirstName ? patient.guardianFirstName : null;
        patient.guardianLastName = patient.guardianLastName ? patient.guardianLastName : null;
        this.setState({showLoading:true}, async() => {
            try{
                let result = await PatientAPI.editPatient(patient)
                if(result.success){
                    sweetalert.fire({icon: 'success', title: '', text: 'Patient saved'}).then(()=>{
                        this.setState({
                            selectedPatient: {
                                ID: null,
                                uid: "",
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                email: '',
                                phoneNumber: '',
                                dateOfBirth: '',
                                streetAddress: '',
                                city: '',
                                state: '',
                                zipcode: '',
                                country: '',
                                county: '',
                                streetAddress2: '',
                                customerID:null,
                                genderID:null,
                                ethnicityID:null,
                                raceID:null,
                                guardianFirstName: '',
                                guardianLastName: '',
                                FacilityIDs: null
                            } as Patient
                        }, () => {
                            PatientAPI.getPatientsFromPatientPortal().then(data => {
                                this.setState({patients: data.patients, showLoading: false})
                            })
                            this.queryPatients(this.state.selected_page.value);
                        });
                    });
                }else{
                    sweetalert.fire({icon: 'error', title: '', text: result.reason});
                    this.setState({showLoading:false})
                }
            }
            catch (e) {
                console.error(e)
                this.setState({showLoading:false})
            }
        })
    }

    handleExportToCSV(){
        this.setState({showLoading: true}, async () =>{
            await NetworkUtil.downloadCSV(
                "/api/admin/patient/csv",
                "Patient Management Data.xlsx",
                {filter: this.state.filter}
            )
            this.setState({showLoading: false})
        });
    }

    useSorter(col:Column){
        let sorter = new Sorter<any>()

        this.setState({tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any,this.state.direction), direction: this.state.direction === 'asc' ? 'desc' : 'asc'});
    }

    changePage(page:number){
        let allPatients = this.state.patientQueryResults;
        let returnData = slicePages(allPatients, page, ITEMS_PER_PAGE);
        this.setState({ tableData: returnData });
    }

    renderPatientMgmtFilterFields(){
        return (
            <FilterCard fields={[
                {
                    label: "UID",
                    "key": "uid",
                    type: FIELD_TYPE.TEXT,
                },
                {
                    label: "First Name",
                    "key": "firstName",
                    type: FIELD_TYPE.TEXT,
                }, 
                {
                    label: "Last Name",
                    "key": "lastName",
                    type: FIELD_TYPE.TEXT,
                }, 
                { label: "Date of Birth", key: "dateOfBirth", type: FIELD_TYPE.DATE },
                {
                    label: "Gender",
                    "key": "genderID",
                    type: FIELD_TYPE.SELECT,
                    options: this.state.genders,
                    isMapped: true,
                    isMulti: true,
                    textType: 'text'
                },
                {
                    label: "Ethnicity",
                    "key": "ethnicityID",
                    type: FIELD_TYPE.SELECT,
                    options: this.state.ethnicities,
                    isMapped: true,
                    isMulti: true,
                    textType: 'text'
                },
                {
                    label: "Race",
                    "key": "raceID",
                    type: FIELD_TYPE.SELECT,
                    options: this.state.races,
                    isMapped: true,
                    isMulti: true,
                    textType: 'text'
                },
            ]} filterChanged={(e)=> this.setState({ filter: e })} />
        )
    }

    render() {

        return (<React.Fragment>
            <Overlay show_loading={this.state.showLoading}/>
            <InBetweenOverlay showInBetween={this.state.showInBetween} />
            <PatientManagementModal
                selectedPatient={this.state.selectedPatient}
                onSubmit={(patient:Patient) => {
                    hideModal(PatientManagementModal.ID);
                    this.modifyPatient(patient);
                }}
                genders={this.state.genders}
                ethnicities={this.state.ethnicities}
                races={this.state.races}
                states={this.state.states}
                countries={this.state.countries}
                facilities={this.state.facilities}
            />
            <div className="container-fluid ">
                <div className={"row"}>
                    <div className="col-12 col-lg-8 col-xl-5 pt-2">
                        <div className="card mb-2">
                            <div className="card-header verlag-bold">
                                <h4>Patient Management</h4>
                            </div>
                            <div className="card-body">
                                {this.renderPatientMgmtFilterFields()}
                            </div>
                            <div className="card-footer">
                                <button className={"btn immySubmitButtonOutline "}
                                        onClick={ () => {
                                            this.setState({
                                                selected_page: {label: 1, value: 1}}, () => {
                                                this.queryPatients(this.state.selected_page.value)
                                            })
                                        }}
                                >Search</button>
                            </div>
                        </div>
                    </div>



                    {
                        this.state.tableData &&
                        this.state.tableData.length > 0 &&

                        <div className="col-12 pt-2">
                            <div className="card mt-2 mb-5">
                                <div className="card-header verlag-bold stickToTop">
                                    <h4 className="text-center text-md-left">Patients
                                    <button className={"ml-2 d-none d-md-inline btn btn-outline-primary"} onClick={() => this.handleExportToCSV()} >Export to CSV </button>
                                    <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                                    <h4 style={{ float: "right" }}>Total: {this.state.patientQueryResults.length}</h4>
                                    <h4 className="float-right align-middle pr-2 ml-5">Page </h4>
                                    <div className=" align-middle float-right pages ">
                                        <Select
                                            isSearchable={true}
                                            placeholder={"1"}
                                            noOptionsMessage={() => "No option"}
                                            value={this.state.selected_page}
                                            onChange={(e: ReactSelect) => this.setState({selected_page: e},
                                                () => this.changePage(e.value))}
                                            className={"state_select"}
                                            options={this.state.page_options}
                                        />
                                    </div>
                                    </section>    
                                    </h4>
                                </div>
                                <div className="card-body p-0 m-0 table-responsive">
                                    <SimpleTable table_style='tableFixHead' columns={[
                                        {
                                            label: "Name", key: "",
                                            rawFormat: (val) => {
                                                return <a href={"#!"} onClick={() => {
                                                    this.setState({selectedPatient: val}, () => showModalNoOutsideClick(PatientManagementModal.ID))
                                                }}>{val.firstName} {val.lastName}</a>
                                            },
                                            popoverText: "Click to sort by Name"
                                        },
                                        {
                                            label: "UID", key: "uid",
                                            popoverText: "Click to sort by UID"
                                        },
                                        {
                                            label: "Date of Birth", key: "dateOfBirth",
                                            popoverText: "Click to sort by Date of Birth", formatFunc: parseDate
                                        },
                                        {
                                            label: "Email", key: "email",
                                            popoverText: "Click to sort by Email"
                                        },
                                        {
                                            label: "Phone #", key: "phoneNumber",
                                            popoverText: "Click to sort by Phone #"
                                        },
                                        {
                                            label: "City", key: "city",
                                            popoverText: "Click to sort by City"
                                        },
                                        {
                                            label: "State", key: "state",
                                            popoverText: "Click to sort by State"
                                        },
                                    ]} table_data={this.state.tableData} columnClickedCallback={(col =>{
                                        this.useSorter(col);
                                    })} />
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </React.Fragment>)
    }
}